module.exports = __webpack_public_path__ + "img/download.0c8ebc75.png";